import { Inject, Injectable } from '@angular/core';
import { PaymentGatewayIntent, PaymentChannelCode, PaymentGatewayMethods } from '../ridango.models';
import { HttpClient } from '@angular/common/http';
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import { finalize, map, take } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class PaymentGatewayService {
    private isProcessing = false;

    constructor(
        private http: HttpClient,
        @Inject('ENV') private env
    ) {}

    createPaymentIntent(intent: PaymentGatewayIntent): void {
        if (this.isProcessing) return;
        this.isProcessing = true;

        const paymentMethod = this.getPaymentMethod(intent.code);
        const url = `${this.env.PAYMENT_GATEWAY_URL}/${this.env.REGION_ID}/${paymentMethod}/intent`;

        this.http
            .post(url, intent, { responseType: 'text' })
            .pipe(
                map((intent: string) => {
                    return `${this.env.PAYMENT_GATEWAY_URL}/${this.env.REGION_ID}/${paymentMethod}/payment/${intent}`;
                }),
                take(1),
                finalize(() => {
                    this.isProcessing = false;
                })
            )
            .subscribe((paymentUrl: string) => {
                if (Capacitor.isNativePlatform()) {
                    Browser.open({ url: paymentUrl });
                } else {
                    window.open(paymentUrl, '_self');
                }
            });
    }

    private getPaymentMethod(code: string): string {
        switch (code) {
            case PaymentChannelCode.VPO:
                return PaymentGatewayMethods.VPO;
            default:
                return PaymentGatewayMethods.LEGACY;
        }
    }
}
